module.exports = "/images/google-play.png";